import { render, staticRenderFns } from "./TmsFacetExtras.vue?vue&type=template&id=a9c9199c"
import script from "./TmsFacetExtras.ts?vue&type=script&lang=ts&external"
export * from "./TmsFacetExtras.ts?vue&type=script&lang=ts&external"
import style0 from "./TmsFacetExtras.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports